
import { Component, Vue, Watch, Emit, Prop } from "vue-property-decorator";
import { namespace, Getter, State, Mutation } from "vuex-class";

import {
	axiosJsonInstance
} from "@/axios.instance";
import { ILatLng, convertStringToLatLng } from "@sureview/v2-mapping";

import {
	Guard,
	GuardTour,
	DispatchableEvent,
	MapOptions,
	DispatchStatus,
	GuardsByStatus,
	EventStatus,
	DispatchQueue,

	GuardDispatchQueue,
	DispatchApi
} from "@sureview/v2-dispatch"

import mobileApi from "@/services/api.mobile.service";
const dispatchApi = new DispatchApi(axiosJsonInstance);

const Mobile = namespace("mobile");

@Component({
	components: {
	}
})
export default class DispatchGuardDetails extends Vue {
	@Prop()
	guard: Guard;

	@Prop()
	alarms: DispatchableEvent[];

	@Prop()
	currentUser: {
		userId: number,
		fullName: string;
	};

	@Prop({ type: Boolean, default : false})
	userCanCancelDispatch: boolean;

	dispatchQueue: DispatchQueue[] = [];

	dispatching: boolean = false;
	cancelActive: boolean = false;

	get DispatchStatus() {
		return DispatchStatus;
	}

	get dispatchableAlarms() {
		if (!this.dispatchQueue) return this.alarms;

		return this.alarms.filter(a => !this.dispatchQueue.some(q => q.eventID === a.eventId));
	}

	public async mounted() {
		if (this.guard) {
			this.dispatchQueue = await dispatchApi.dispatchQueue(this.guard.guardId);
		}
	}

	dispatchToAlarm(alarm: DispatchableEvent, location: ILatLng) {
		mobileApi.addDispatchRequest(this.guard.guardId, null, alarm.eventId,
			this.currentUser.fullName, "Dispatch to area and investigate",
			location.lat + " " + location.lng, "");
		this.dispatching = false;
	}

	async cancelActiveDispatchQueue() {
		const activeDispatch = this.dispatchQueue.find(q => q.eventID === this.guard.eventId);
		if (activeDispatch) {
			await mobileApi.finishDispatchRequest(activeDispatch.dispatchQueueID, this.guard.guardId);
			this.dispatchQueue = await dispatchApi.dispatchQueue(this.guard.guardId);
		}

		this.cancelActive = false;
	}

	async cancelDispatchQueue(dispatchQueueItem: DispatchQueue) {
		await mobileApi.finishDispatchRequest(dispatchQueueItem.dispatchQueueID, this.guard.guardId);
		this.dispatchQueue = await dispatchApi.dispatchQueue(this.guard.guardId);
	}

	startDispatch() {
		this.dispatching = true;
	}

	gotoAlarmLocation(queueLocation: string) {
		this.$emit("gotoLocation", convertStringToLatLng(queueLocation));
	}
}
